// Depedencies
import React from 'react'

const useAnimatedRender = (force: boolean = true) => {
  const [shouldRender, setShouldRender] = React.useState<boolean>(false);
  const animationFrameRequest = React.useRef<number>(0);

  React.useEffect(() => {
    animationFrameRequest.current = requestAnimationFrame(() => {
      setShouldRender(force);
    })
    return () => cancelAnimationFrame(animationFrameRequest.current);
  }, [force])

  return shouldRender;
}

export default useAnimatedRender
